<template>
  <div class="footBox">
    <div class="footBox_content">
      <div class="footBox_item">
        <div class="footBox_item_left">
          <p>服务与支持</p>
          <p>产品与方案</p>
          <p>合作共赢</p>
          <p>典型案例</p>
        </div>
        <div class="footBox_item_middleBox">
          <div class="footBox_item_middle">
            <p>联系我们</p>
            <p>Add：江苏省南京市雨花台区软件大道119号丰盛商汇1栋4层</p>
            <p>Tel：4000-119-329 / 025-51873146 / 17705155317</p>
            <div>
              <img src="static/image/microblog.png" alt="">
              <img src="static/image/wechart.png" alt="">
              <img src="static/image/qq.png" alt="">
            </div>
          </div>
        </div>
        <div class="footBox_item_right">
          <img src="static/image/wx_jr.png" alt="">
          <p>关注消管通</p>
        </div>
      </div>
      <div class="footBox_txt">
        <span>Copyright © 2013-现在 南京久润安全科技有限公司 版权所有</span>
        <span @click="toSu">{{recordStr}}</span>
      </div>
    </div>
    <div class="toUpBox" @click="toTop" v-if="showTop">
      <el-tooltip class="item" effect="dark" content="返回顶部" placement="bottom">
        <img  src="static/image/up_icon.png" alt="">
      </el-tooltip>
    </div>
  </div>
</template>

<script>
    export default {
        name: "footerCom",
      data(){
          return{
            showTop:false,
            urlStr:"",
            recordStr:"",
          }
      },
      created(){
        var that = this;
        this.urlStr = window.location.href;
        if(this.urlStr.indexOf("xgt2014") != -1){
          this.recordStr = "苏ICP备15037993号-2";
        }else{
          this.recordStr = "苏ICP备15037993号-4";
        }
        window.addEventListener('scroll',function (e) {
          if((document.documentElement.scrollTop || document.body.scrollTop)>200){
            that.showTop = true;
          }else{
            that.showTop = false;
          }

        })
      },
      methods:{
        toSu(){
          window.open("http://beian.miit.gov.cn/")
        },
        toTop(){
          var currentScroll = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
          if (currentScroll > 0) {
            window.requestAnimationFrame(this.toTop);
            document.documentElement.scrollTo (0,currentScroll - (currentScroll/5));
          }
        },
      }
    }
</script>

<style scoped>
  .footBox{
    width: 100%;
    height: 290px;
    box-sizing: border-box;
    background: #212842;
    display: flex;
    justify-content: center;
    color: #fff;
  }
  .footBox_content{
    width: 1200px;
    height: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
  }
  .footBox_item{
    flex: 1;
    box-sizing: border-box;
    padding: 5% 0;
    display: flex;
  }
  .footBox_txt{
    width: 100%;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size:12px;
    font-family:PingFang SC;
    font-weight:400;
    color:rgba(187,193,210,1);
  }
  .footBox_txt span:nth-of-type(1){
    padding: 0 10px 0 0;
  }
  .footBox_txt span:nth-of-type(2),.footBox_txt span:nth-of-type(3){
    padding: 0 10px;
  }
  .footBox_txt span:nth-of-type(4){
    padding: 0 3px 0 0;
  }
  .footBox_item_left{
    width: 20%;
    height: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    padding: 0 0 0 5%;
  }
  .footBox_item_right{
    width: 20%;
    height: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    padding: 0 0 0 8%;
  }
  .footBox_item_right img{
    width: 100px;
    height: 90px;
  }
  .footBox_item_middleBox{
    flex: 1;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    border-left: 1px solid #2D3959;
    border-right: 1px solid #2D3959;
  }
  .footBox_item_right p{
    font-size:12px;
    font-family:PingFang SC;
    font-weight:400;
    color:rgba(187,193,210,1);
    padding: 8px 0 8px 20px;
  }
  .footBox_item_left p:nth-of-type(1),.footBox_item_middle p:nth-of-type(1){
    font-size: 14px;
    padding:0 0 16px 0;
  }
  .footBox_item_left p:nth-of-type(2),.footBox_item_left p:nth-of-type(3),.footBox_item_left p:nth-of-type(4),.footBox_item_middle p:nth-of-type(2),.footBox_item_middle p:nth-of-type(3){
    font-size:12px;
    font-family:PingFang SC;
    font-weight:400;
    color:rgba(187,193,210,1);
    padding: 8px 0;
  }
  .footBox_item_middle{
    width: 330px;
  }
  .toUpBox{
    position: fixed;
    right:100px;
    top:calc(100vh - 200px);
    z-index: 99999;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/footerCom.vue